import { Contact } from '@macs-frontend/features/shared/models/contact';

export type ContactKind = 'client-user' | 'contact';

export type ContactKindSource = Partial<
  Pick<Contact, 'hasRelatedClientUser' | 'clientUsers'>
>;

export function contactKind(
  contact: ContactKindSource | null | undefined,
  clientUuid?: string | null,
): ContactKind {
  if (!clientUuid) {
    return contact?.hasRelatedClientUser === true ? 'client-user' : 'contact';
  }

  const clientUsers = Object.values(contact?.clientUsers ?? {});

  return clientUsers.some(
    clientUser => String(clientUser?.clientUuid) === String(clientUuid),
  )
    ? 'client-user'
    : 'contact';
}
